import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPix } from '@fortawesome/free-brands-svg-icons'
import {
  faHouse,
  faUserGroup,
  faUserShield,
  faUsers,
  faPenFancy,
  faAnglesLeft,
  faAnglesRight,
  faAngleLeft,
  faAngleRight,
  faHashtag,
  faTriangleExclamation,
  faCircleExclamation,
  faSpinner,
  faEye,
  faEyeSlash,
  faShuffle,
  faRightToBracket,
  faDownload,
  faPaperPlane,
  faClockRotateLeft,
  faInfinity,
  faInbox,
  faEnvelopeOpen,
  faComputerMouse,
  faSkullCrossbones,
  faSearch,
  faList,
  faPowerOff
} from '@fortawesome/free-solid-svg-icons'


//look out:
// https://fontawesome.com/search?o=r&m=free

//icon to use
library.add(
  faHouse,
  faUserGroup,
  faUserShield,
  faUsers,
  faPenFancy,
  faAnglesLeft,
  faAnglesRight,
  faAngleLeft,
  faAngleRight,
  faHashtag,
  faTriangleExclamation,
  faCircleExclamation,
  faSpinner,
  faEye,
  faEyeSlash,
  faShuffle,
  faRightToBracket,
  faDownload,
  faPix,
  faPaperPlane,
  faClockRotateLeft,
  faInfinity,
  faInbox,
  faEnvelopeOpen,
  faComputerMouse,
  faSkullCrossbones,
  faSearch,
  faList,
  faPowerOff
);

export { FontAwesomeIcon };
